<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

interface Props {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
</script>

<template>
  <div
    :class="
      cn(
        'is-user:dark flex w-fit flex-col gap-2 overflow-hidden text-sm',
        'group-[.is-user]:ml-auto group-[.is-user]:rounded-lg group-[.is-user]:bg-indigo-600 group-[.is-user]:px-4 group-[.is-user]:py-3 group-[.is-user]:text-white',
        'group-[.is-assistant]:text-gray-900 group-[.is-assistant]:dark:text-gray-100',
        props.class
      )
    "
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
